export const SET_TOKEN = "WIZARD/SET_TOKEN";
export const SET_STATUS = "WIZARD/SET_STATUS";
export const SET_INVOCATIONS = "WIZARD/SET_INVOCATIONS";
export const DELETE_INVOCATIONS = "WIZARD/DELETE_INVOCATIONS";
export const SET_PAYMENT_INTENT_SECRET = "WIZARD/SET_PAYMENT_INTENT_SECRET";
export const SET_PAYMENT_DETAILS = "WIZARD/SET_PAYMENT_DETAILS";
export const SET_PUBLISHER = "WIZARD/SET_PUBLISHER";
export const IS_PROCESSING_PAYMENT = "WIZARD/IS_PROCESSING_PAYMENT";
